module.exports = __webpack_public_path__ + "static/media/programming-process-svgrepo-com.6a3dcff8.svg";